export default __webpack_public_path__ + "media/images/images/flags/ri-705e14e543f81973a35bb27692fd5022.png";